import React, { useEffect, useRef, useState } from 'react';

const NotificationBox = (props) => {
    const {
        message,
        open,
        handleToggle
    } = props;

    const notificationBoxRef = useRef();
    const [maximizedItems, setMaximizedItems] = useState({});
    const [readItems, setReadItems] = useState({});
    const handleNotifState = (id) => {
        setMaximizedItems((preMaximizedItems) => ({
            ...preMaximizedItems,
            [id]: !preMaximizedItems[id]
        }));
        setReadItems((preMaximizedItems) => ({
            ...preMaximizedItems,
            [id]: true
        }));
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            setTimeout(() => {
                if (notificationBoxRef.current && !notificationBoxRef.current.contains(event.target) && open) {
                    handleToggle();
                }
            }, 150);
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [handleToggle, open]);

    return (<>
        <div className={`notification-box ${open ? 'notif-active' : ''}`} ref={notificationBoxRef}>
            <div className="triangle-top"></div>

            <div className={`message-box ${(message === null || (message && message.length === 0)) && "text-center"}`}>
                <div className="p-3 mb-4 notif-heading">お知らせ一覧</div>
                {
                    message && message.length > 0 ? message.map((data) => {
                        return (
                            <>
                                <div onClick={() => handleNotifState(data.announcement_id)} className={`message ${readItems[data.announcement_id] ? 'read' : ''}`}>
                                    <div className='image-box'>
                                        <img src="/img/circle-red.png" alt="redCircle" className={` ${!readItems[data.announcement_id] ? 'visible' : 'hidden'}`} />
                                    </div>
                                    <div className='main-box ml-3 pb-2'>
                                        <div>
                                            <div className='date'>{data.target_time}</div>
                                            <div className='title'>{data.title}</div>
                                        </div>
                                        {/* <div className='content'>{data.content}</div> */}
                                        <div className={`content ${maximizedItems[data.announcement_id] ? 'visible' : 'hidden'}`}
                                            // dangerouslySetInnerHTML={{ __html: data.content.replace(/(?:\\[rn]|[\r\n]+)+/g, '<br />').replaceAll("<a", '<a target="_blank" ') }} 
                                            // dangerouslySetInnerHTML={{
                                            //     __html: data.content
                                            //         .replace(/<a\s+href="([^"]*)"\s*>(.*?)<\/a>/g, (match, url, linkText) => {
                                            //             if (!linkText.trim()) {
                                            //                 linkText = url;
                                            //             }
                                            //             return `<a href="${url}" target="_blank" style="color: #233c6b;">${linkText}</a>`;
                                            //         })
                                            //         .replace(/(?:\\[rn]|[\r\n]+)+/g, '<br />')
                                            // }}
                                            dangerouslySetInnerHTML={{
                                                __html: data.content
                                                    .replace(/(?:\\[rn]|[\r\n]+)+/g, '<br />')  // Replace line breaks
                                                    .replace(/(https?:\/\/[^\s]+)/g, (match) => {
                                                        return `<a href="${match}" style="color: #233c6b; text-decoration: underline;">${match.includes('athena') ? 'ダウンロード' : match}</a>`;
                                                    })
                                            }}
                                        />
                                    </div>
                                    <div className={`image-box ${maximizedItems[data.announcement_id] ? 'toggle-alignment' : ''}`}>
                                        <img src={`${maximizedItems[data.announcement_id] ? '/img/min.png' : '/img/max.png'}`} alt="symbol" />
                                    </div>

                                </div>

                            </>
                        )
                    }) : "現在通知はありません。"
                }
            </div>
        </div>
        {/* <div class="modal-backdrop fade show"></div> */}
    </>
    );
}
export default NotificationBox;